var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div><flash-message duration=\"5000\" show-close=\"true\"></flash-message></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/supportMessage/supportMessage.jade
// module id = 510
// module chunks = 0